export const countSelector = (response: { count: number }) => response.count;

export const hasOrdersSelector = <T extends { count: number }>({ count }: T) => count > 0;
